export default __webpack_public_path__ + "static/priority_Medium.86cbec2d57053defbf66dec0dc3640ee.svg";